import { ModalTemplateWrapper } from '../ModalTemplateWrapper/ModalTemplateWrapper.js';
import { type CommonTemplateProps } from '../types.js';

type IndependentCongratsLiveProjectModalProps = CommonTemplateProps & {
  readonly onClose?: () => void;
};

export const IndependentCongratsLiveProjectModal = ({
  closeModal,
  isOpen,
  onClose,
}: IndependentCongratsLiveProjectModalProps) => {
  const handleClose = () => {
    onClose?.();
    closeModal();
  };

  return (
    <ModalTemplateWrapper
      ariaLabel="independent-congrats-live-project-modal"
      ctaOptions={{
        primaryCTA: {
          handleOnClick: handleClose,
          isLoading: false,
          label: "I'm Ready",
        },
      }}
      desktopModalSize="md"
      headerText="Great news, your project is live! 🎉"
      isOpen={isOpen}
      onClose={handleClose}
      subheaderText="Strap in, it's time to get to work! 🏃 ️You'll be able to
      manage everything related to this project within this workspace."
    />
  );
};
